"use strict";import{Banner as e}from"./src/Banner.js";import{defineElement as n}from"@spectrum-web-components/base/src/define-element.js";n("sp-banner",e);
//# sourceMappingURL=sp-banner.js.map
